var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseRemoteService } from "../core/BaseRemoteService";
import { paramsToSearchString } from "../../utils/urlHelper";
export class ActivitiesService extends BaseRemoteService {
    getAll(caseId, params = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            params = Object.assign(Object.assign({}, params), { 
                // the endpoint is a paging endpoint, but we are not bothered about paging activities
                pageSize: 999999 });
            const url = `${this.apiRoot}/cases/${caseId}/activities/${paramsToSearchString(params)}`;
            const response = yield this.getRequest(url);
            return (_a = response.data) === null || _a === void 0 ? void 0 : _a.reverse();
        });
    }
    get(caseId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/activities/${id}`;
            return yield this.getRequest(url);
        });
    }
    newCaseNote(caseId, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/case-notes/`;
            return yield this.postRequest(url, model);
        });
    }
    newComms(caseId, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/case-comms/`;
            return yield this.postRequestFormData(url, model);
        });
    }
    newDocument(caseId, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/documents/`;
            return yield this.postRequestFormData(url, model);
        });
    }
    downloadDocument(caseId, documentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/documents/${documentId}/download`;
            return yield this.getRequestBlob(url);
        });
    }
    downloadDocumentCaseDocumentsEvent(caseId, documentId, blobId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/activities/${documentId}/documents/${blobId}/download`;
            return yield this.getRequestBlob(url);
        });
    }
    downloadDocumentAttachment(caseId, activityId, attachmentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/emails/${activityId}/attachments/${attachmentId}/download`;
            return yield this.getRequestBlob(url);
        });
    }
    transferCase(caseId, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/transfers/`;
            return yield this.postRequest(url, model);
        });
    }
    toggleFlag(caseId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/activities/${id}/toggle-flag`;
            return yield this.postRequest(url);
        });
    }
    assignCaseLead(caseId, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/case-leads`;
            return yield this.postRequest(url, model);
        });
    }
    assignCase(caseId, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/assign-case`;
            return yield this.postRequest(url, model);
        });
    }
    closeCase(caseId, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/close`;
            return yield this.postRequest(url, model);
        });
    }
    reopenCase(caseId, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/reopen`;
            return yield this.postRequest(url, model);
        });
    }
    cloneCase(caseId, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/clone`;
            return yield this.postRequest(url, model);
        });
    }
    attachEmail(caseId, mailId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/emails`;
            const response = yield this.postRequest(url, { mailId });
            return !!response;
        });
    }
    pauseCaseSla(caseId, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/pause`;
            return yield this.postRequest(url, model);
        });
    }
    restartCaseSla(caseId, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/restart`;
            return yield this.postRequest(url, model);
        });
    }
    getLatestSlaActivity(caseId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/activities/sla`;
            return yield this.getRequest(url);
        });
    }
    editActivity(caseId, reason, note, meta) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/edit`;
            return yield this.postRequest(url, { reason, note, meta });
        });
    }
    internalMessage(caseId, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/cases/${caseId}/internal-message`;
            model.upns = model.upns.map((x) => x.id);
            const internalMessageSerialised = JSON.stringify(model);
            return yield this.postRequestFormData(url, { files: model.file, internalMessageSerialised });
        });
    }
}
